import kebabCase from 'lodash/kebabCase';
import React from 'react';
import logoDark from './assets/logo-dark.svg';
import logoLight from './assets/logo-light.svg';
import logoXiuXiuDark from './assets/logo-xiuxiu-dark.svg';
import logoXiuXiuLight from './assets/logo-xiuxiu-light.svg';
import logo from './assets/logo.svg';
import newIcon from './assets/new.svg';
import notVip from './assets/not-vip.svg';
import vip from './assets/vip.svg';

const assets = Object.entries({
    logo,
    logoDark,
    logoLight,
    logoXiuXiuDark,
    logoXiuXiuLight,
    newIcon,
    notVip,
    vip,
}).reduce((prev, [key, value]) => {
    if (key === 'newIcon') {
        prev['new'] = value;
        return prev;
    }

    prev[kebabCase(key)] = value;

    return prev;
}, {});

export interface ISvgIconProps {
    name: string;
    width: number;
    height: number;
    title?: string;
}

const SvgIcon = ({ name, width, height, title = '' }: ISvgIconProps) => {
    return (
        <img
            style={{ pointerEvents: 'none' }}
            title={title}
            alt={name}
            src={assets[name]}
            width={width}
            height={height}
        />
    );
};

export default SvgIcon;
